import { ACTION_GCASH_ADD_TRANSACTION, ACTION_GCASH_ADD_TRANSACTION_ERROR, ACTION_GCASH_ADD_TRANSACTION_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const gcashAddTransactionReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GCASH_ADD_TRANSACTION:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_GCASH_ADD_TRANSACTION_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_GCASH_ADD_TRANSACTION_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}